import { render, staticRenderFns } from "./Sperrterminliste.vue?vue&type=template&id=c1e20db4"
import script from "./Sperrterminliste.vue?vue&type=script&lang=js"
export * from "./Sperrterminliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports